import { render, staticRenderFns } from "./ModeSwitcher.vue?vue&type=template&id=70ea19ce&scoped=true&lang=pug&"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js&"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ModeSwitcher.vue?vue&type=style&index=0&id=70ea19ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea19ce",
  null
  
)

export default component.exports